import PropTypes from 'prop-types';
import { SET_APP_USER, SET_APP_DATA, APP_HEARTBEAT, LOAD_PROMOTIONS, LOAD_LOCATIONS, UPDATE_PENDING_PROMOTIONS, UPDATE_PENDING_PROMOTIONS_FROM_LIVE, REPLACE_LOCATIONS } from './App.actions';
import { createLookupMap } from './App.functions';

export const propTypes = {
    user: PropTypes.object,
    data: PropTypes.object,
    appIsDown: PropTypes.bool,
    newContentAvailable: PropTypes.bool,
    isPrepared: PropTypes.bool,
    promotions: PropTypes.array,
    locations: PropTypes.array,
    lookups: PropTypes.object,
};

export const defaultProps = {
    user: null,
    data: null,
    appIsDown: null,
    newContentAvailable: null,
    isPrepared: null,
    promotions: null,
    locations: null,
    lookups: {
        locations: {},
        promotions: {}
    }
};

export const mapStateToProps = {
    app: ( state, action ) => {
        switch ( action.type ) {
            case SET_APP_USER:
                return {
                    ...state,
                    user: action.user,
                };
            case SET_APP_DATA:
                return {
                    ...state,
                    data: action.data,
                };
            case APP_HEARTBEAT:
                return {
                    ...state,
                    appIsDown: !action.ping
                };
            case LOAD_PROMOTIONS:
		        return {
			        ...state,
			        promotions: action.promotions,
                    lookups: {
                        ...state.lookups,
                        promotions: createLookupMap( action.promotions )
                    }
		        };
	        case LOAD_LOCATIONS:
		        return {
			        ...state,
			        locations: action.locations,
                    lookups: {
                        ...state.lookups,
                        locations: createLookupMap( action.locations )
                    }
		        };
            case REPLACE_LOCATIONS:
                return {
                    ...state,
                    locations: state.locations.map( location => {
                        let replaceLocation = null;
                        action.locations.forEach( loc => {
                            if ( loc.ID === location.ID ) {
                                replaceLocation = { ...loc };
                            }
                        });
                        return replaceLocation || location;
                    })
                };
            case UPDATE_PENDING_PROMOTIONS:
                return {
                    ...state,
                    locations: state.locations.map( location => {
                        if ( action.selections.locations.indexOf( location.ID ) === -1 ) {
                            return location;
                        }

                        let newLocation = {
                            ...location,
                            pending_promotions: ( location.pending_promotions || [] ).slice(0) // creates a clone
                        };
                        if ( action.selections.multiple ) {
                            newLocation.pending_promotions = action.selections.promo.slice(0); // creates a clone of the array
                        } else {
                            // If we're swapping a promo out of the box, we'll remove the original promo out of pending_promotions
                            if ( location[ action.selections.box ] ) {
                                newLocation.pending_promotions = newLocation.pending_promotions.filter( promo => {
                                    return promo !== location[ action.selections.box ];
                                });
                            }
                            newLocation[ action.selections.box ] = action.selections.promo;
                        }

                        // Let's make sure that any promos that are in boxes but not in pending_promotions stick around
                        ['a','b','c','alert'].forEach( box => {
                            const promo = newLocation['pending_box_'+box];
                            if ( promo && newLocation.pending_promotions.indexOf( promo ) === -1 ) {
                                newLocation.pending_promotions.push( promo );
                            }
                        });

                        return newLocation;
                    })
                };
            case UPDATE_PENDING_PROMOTIONS_FROM_LIVE:
                return {
                    ...state,
                    locations: state.locations.map( location => {

                        if ( action.location && location.ID !== action.location.ID ) {
                            return location;
                        }

                        return {
                            ...location,
                            pending_box_a: location.promo_box_a,
                            pending_box_b: location.promo_box_b,
                            pending_box_c: location.promo_box_c,
                            pending_box_alert: location.promo_box_alert,
                            pending_promotions: location.active_promotions,
                        }
                    })
                };
            default:
                return state;
        }
    }
};

export const mapDispatchToProps = {
};